module.exports = __webpack_public_path__ + "img/icon-tiktok.8a6d27a4.svg";